import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
	Container, Row, Col, Modal, ModalHeader, ModalBody,
	ModalFooter, Card, CardBody, Button, Form, FormGroup,
	Label, Input, FormFeedback, Alert, Table
} from 'reactstrap';
import MaterialTable from '@material-table/core';
import axios from 'axios';
import { Add, Edit, Delete } from '@material-ui/icons';
import swal from 'sweetalert';
import moment from 'moment';

import backend_url from "../../../routes/API_URL";
import Loader from "../../../components/Loader";
import GanttChart from '../../common/Recommendations/Gantt';

const API_URL = backend_url['api_url'];

class InspectionFollowup extends Component {
	constructor(props) {
		super(props);
		this.tableRef = React.createRef();
		this.state = {
			// User info
			role: window.sessionStorage.getItem("urole"),
			bearer_auth: window.sessionStorage.getItem('token'),
			logged_user_id: window.sessionStorage.getItem('uid'),
			sector_id: window.sessionStorage.getItem("sector"),

			// Modal states
			modalVisible: false,
			EditModalVisible: false,
			toggleCalendar: false,
			showOptions: true,

			// Optimized pagination states
			page: 0,
			pageSize: 10,
			totalCount: 0,
			searchText: '',
			loading: false,
			isFetching: false,
			error: null,
			rawResponse: null,

			// Data states
			Visits: [],
			VisitTypes: [],
			recentVisits: [],
			Users: [],
			Sectors: [],
			Districts: [],
			Zones: [],
			Divisions: [],
			Schools: [],
			years: [],

			// Form states
			id: '',
			school_id: '',
			zone_id: '',
			district_id: '',
			division_id: '',
			assoc_visit: '',
			head_teacher: '',
			phone_number: '',
			present_visitation_date: moment().format("YYYY-MM-DD"),
			prev_visitation_date: '',
			lead_inspector_id: '',
			first_inspector_id: '',
			second_inspector_id: '',
			third_inspector_id: '',
			fourth_inspector_id: '',
			school_address: '',
			establishment_year: '',
			establishment: '',
			enrolment_boys: '',
			enrolment_girls: '',
			attendance_boys: '',
			attendance_girls: '',
			number_of_teachers: '',
			unqualified_teachers: '',
			publication_date: '',
			action_plan_date: '',
			next_inspection_date: '',
			lead_advisor_id: '',
			govt_chair_id: '',
			visit_type_id: 2,
			extra_comments: '',

			// Recommendations
			MajorRecommendations: [],
			MinorRecommendations: [],
			follow_up_comments: [], // Changed to match DB column name
			followup_status: [], // Will store need_extra_followups values
			ActionPlans: [],
			categories: [],
			national_standards: [],

			// Validation states
			SchoolIdState: '',
			ZoneIdState: '',
			DistrictIdState: '',
			DivisionIdState: '',
			HeadTeacherIdState: '',
			presentDateState: '',
			prevDateState: '',
			leadInspectorIdState: '',
			firstInspectorIdState: '',
			secondInspectorIdState: '',
			thirdInspectorIdState: '',
			fourthInspectorIdState: '',
			SchoolAddressState: '',
			EstYearState: '',
			EstState: '',
			EnrolledBoysState: '',
			EnrolledGirlsState: '',
			AttendanceBoysState: '',
			AttendanceGirlsState: '',
			TotalTeachersState: '',
			UnqualifiedTeachersState: '',
			actionDateState: '',
			nextInspectionDateState: '',
			leadAdvisorIdState: '',
			govChairIdState: '',
			visitTypeIdState: '',

			// Other states
			visit: {},
			followup_visit: {},
			ExpiryVisitDate: '',
			expiryDateMessage: '',
			jurisdiction: '',
			isExpired: false
		};

		this.toggle = this.toggle.bind(this);
		this.toggleEdit = this.toggleEdit.bind(this);
		this.handleInput = this.handleInput.bind(this);
		this.addInspectionVisit = this.addInspectionVisit.bind(this);
		this.editInspectionVisit = this.editInspectionVisit.bind(this);
		this.updateInspectionVisit = this.updateInspectionVisit.bind(this);
		this.deleteInspectionVisit = this.deleteInspectionVisit.bind(this);
		this.filterDistrictsAfterLoad = this.filterDistrictsAfterLoad.bind(this);
		this.filterZonesAfterLoad = this.filterZonesAfterLoad.bind(this);
		this.filterSchoolsAfterLoad = this.filterSchoolsAfterLoad.bind(this);
		this.getRecentVisitsBySchool = this.getRecentVisitsBySchool.bind(this);
		this.setId = this.setId.bind(this);
		this.calculateDateDifference = this.calculateDateDifference.bind(this);
		this.getMinorRecommendationsByVisitId = this.getMinorRecommendationsByVisitId.bind(this);
		this.getMajorRecommendationsByVisitId = this.getMajorRecommendationsByVisitId.bind(this);
		this.getActionPlansByVisitId = this.getActionPlansByVisitId.bind(this);
		this.fetchData = this.fetchData.bind(this);
		this.viewVisitDetails = this.viewVisitDetails.bind(this);
	}

	componentDidMount() {
		this.fetchInitialData();
		this.getYears();
	}

	// Fetch initial dropdown data
	fetchInitialData = () => {
		const bearer_auth = this.state.bearer_auth;

		Promise.all([
			axios.get(API_URL + '/divisions', {
				headers: { "Authorization": `Bearer ${bearer_auth}` }
			}),
			axios.get(API_URL + '/sectors', {
				headers: { "Authorization": `Bearer ${bearer_auth}` }
			}),
			axios.get(API_URL + '/visit_types', {
				headers: { "Authorization": `Bearer ${bearer_auth}` }
			}),
			axios.get(API_URL + '/users', {
				headers: { "Authorization": `Bearer ${bearer_auth}` }
			}),
			axios.get(API_URL + '/national_standards', {
				headers: { "Authorization": `Bearer ${bearer_auth}` }
			})
		])
			.then(([divisions, sectors, visitTypes, users, nationalStandards]) => {
				this.setState({
					Divisions: divisions.data || [],
					Sectors: sectors.data || [],
					VisitTypes: visitTypes.data || [],
					Users: users.data || [],
					national_standards: nationalStandards.data || []
				});
			})
			.catch(error => {
				console.error('Error fetching initial data:', error);
			});
	}

	// Optimized fetchData method with server-side pagination
	// Optimized fetchData method with server-side pagination
	fetchData = (page = 0, pageSize = this.state.pageSize, search = '') => {
		return new Promise((resolve, reject) => {
			this.setState({ isFetching: true, error: null });

			const bearer_auth = this.state.bearer_auth;
			const role = this.state.role;

			// Determine the endpoint based on user role
			let endpoint = '/inspection_visits/followup';
			const params = {
				page: page + 1,
				per_page: pageSize,
				search: search || ''
			};

			// Role-based filtering for follow-up visits
			if (role === 'Division Manager') {
				const div_id = window.sessionStorage.getItem('division');
				endpoint = `/inspection_visits/followup/division/${div_id}`;
			} else if (role === 'DEM') {
				const dist_id = window.sessionStorage.getItem('district');
				endpoint = `/inspection_visits/followup/district/${dist_id}`;
			} else if (role === 'Secondary Advisor' || role === 'PEA') {
				const zon_id = window.sessionStorage.getItem('zone');
				endpoint = `/inspection_visits/followup/zone/${zon_id}`;
			} else if (role === 'Head Teacher') {
				const sch_id = window.sessionStorage.getItem('emis');
				endpoint = `/inspection_visits/followup/school/${sch_id}`;
			}

			axios.get(API_URL + endpoint, {
				headers: {
					"Authorization": `Bearer ${bearer_auth}`,
					"Accept": "application/json"
				},
				params: params
			})
				.then(response => {
					const data = response.data;

					if (data.status && data.status === 'success') {
						const visitsData = data.data || [];
						const totalCount = data.total || 0;

						const transformedVisits = visitsData.map(visit => ({
							...visit,
							school_name: visit.school_name || 'N/A',
							emis_id: visit.emis_id || 'N/A',
							zone_name: visit.zone_name || 'N/A',
							district_name: visit.district_name || 'N/A',
							division_name: visit.division_name || 'N/A',
							present_visitation_date: visit.present_visitation_date || '',
							lead_inspector_id: visit.lead_inspector_id || '',
							visit_type_description: visit.visit_type_description || 'Follow-up'
						}));

						this.setState({
							Visits: transformedVisits,
							totalCount: totalCount,
							page: page,
							pageSize: pageSize,
							loading: false,
							isFetching: false,
							rawResponse: data,
							searchText: search // Save search text for refresh
						}, () => {
							resolve({
								data: transformedVisits,
								page: page,
								totalCount: totalCount
							});
						});
					} else {
						const visitsData = Array.isArray(data) ? data : [];
						const transformedVisits = visitsData.map(visit => ({
							...visit,
							school_name: visit.school_name || 'N/A',
							emis_id: visit.emis_id || 'N/A'
						}));

						this.setState({
							Visits: transformedVisits,
							totalCount: transformedVisits.length,
							page: page,
							pageSize: pageSize,
							loading: false,
							isFetching: false,
							searchText: search
						}, () => {
							resolve({
								data: transformedVisits,
								page: page,
								totalCount: transformedVisits.length
							});
						});
					}
				})
				.catch(error => {
					console.error('Error fetching follow-up inspection visits:', error);
					this.setState({
						isFetching: false,
						loading: false
					});
					this.handleApiError(error);
					reject(error);
				});
		});
	}
	// Optimized API error handling
	handleApiError = (error) => {
		const errorMessage = error.response?.data?.message ||
			error.response?.data?.error ||
			error.message ||
			"Failed to load follow-up inspection visits";

		this.setState({
			loading: false,
			isFetching: false,
			error: errorMessage
		});

		if (error.response?.status === 401) {
			swal({
				title: "",
				text: "Your session has expired. You'll automatically be logged out within seconds.",
				icon: "warning",
				timer: 2000
			}).then(() => {
				window.sessionStorage.clear();
				window.location.reload();
			});
		} else {
			swal({
				title: "Error",
				text: errorMessage,
				icon: "error",
				button: true
			});
		}
	}

	// Get jurisdiction text for follow-up visits
	getJurisdictionText = () => {
		const role = this.state.role;
		const sector_id = this.state.sector_id;

		switch (role) {
			case 'Division Manager':
				const division = window.sessionStorage.getItem('division_name') ||
					window.sessionStorage.getItem('division') || '';
				return `${division} Division's Follow-up Inspection Visits`;
			case 'DEM':
				const district = window.sessionStorage.getItem('district_name') ||
					window.sessionStorage.getItem('district') || '';
				return `${district} District's Follow-up Inspection Visits`;
			case 'Secondary Advisor':
				const zone1 = window.sessionStorage.getItem('zone_name') ||
					window.sessionStorage.getItem('zone') || '';
				return `${zone1} Cluster's Follow-up Inspection Visits`;
			case 'PEA':
				const zone2 = window.sessionStorage.getItem('zone_name') ||
					window.sessionStorage.getItem('zone') || '';
				return `${zone2} Zone's Follow-up Inspection Visits`;
			case 'Head Teacher':
				const school = window.sessionStorage.getItem('school_name') ||
					window.sessionStorage.getItem('emis') || '';
				return `${school} School's Follow-up Inspection Visits`;
			default:
				return "National Follow-up Inspection Visits";
		}
	}

	// View visit details modal
	viewVisitDetails = (visit) => {
		const details = `
Follow-up Date: ${new Date(visit.present_visitation_date).toLocaleDateString()}
Visit Type: ${visit.visit_type_description || 'Follow-up Inspection'}
Lead Inspector: ${this.getInspectorName(visit.lead_inspector_id)}

Zone/Cluster: ${visit.zone_name}
District: ${visit.district_name}
Division: ${visit.division_name}
Sector: ${visit.sector_name || 'N/A'}

Associated Original Visit: ${visit.assoc_visit ? 'Yes' : 'No'}
        `;

		swal({
			title: "Follow-up Visit Details",
			text: details,
			icon: "info",
			content: document.createElement('pre'),
			buttons: {
				close: {
					text: "Close",
					value: "close"
				}
			}
		});
	}

	// Helper to get inspector name
	getInspectorName = (inspectorId) => {
		const inspector = this.state.Users.find(user => user.user_id === inspectorId);
		return inspector ? inspector.user_name : 'N/A';
	}

	// Get status badge color for follow-up visits
	getVisitStatus = (visit) => {
		if (visit.followup_completed) {
			return { color: 'success', text: 'Completed' };
		} else {
			return { color: 'warning', text: 'Pending' };
		}
	}

	// Toggle modals
	toggle() {
		this.setState(prevState => ({
			modalVisible: !prevState.modalVisible,
			EditModalVisible: false,
			school_id: '',
			zone_id: '',
			district_id: '',
			division_id: '',
			assoc_visit: '',
			head_teacher: '',
			phone_number: '',
			present_visitation_date: moment().format("YYYY-MM-DD"),
			prev_visitation_date: '',
			lead_inspector_id: '',
			first_inspector_id: '',
			second_inspector_id: '',
			third_inspector_id: '',
			fourth_inspector_id: '',
			school_address: '',
			establishment_year: '',
			establishment: '',
			enrolment_boys: '',
			enrolment_girls: '',
			attendance_boys: '',
			attendance_girls: '',
			number_of_teachers: '',
			unqualified_teachers: '',
			extra_comments: '',
			activeStep: 0,
			completed: {},
			Districts: [],
			Zones: [],
			Schools: [],
			recentVisits: [],
			MinorRecommendations: [],
			MajorRecommendations: [],
			follow_up_comments: [],
			followup_status: [],
			ActionPlans: []
		}));
	}

	toggleEdit() {
		this.setState(prevState => ({
			EditModalVisible: !prevState.EditModalVisible,
			modalVisible: false
		}));
	}

	calculateDateDifference(date) {
		let inspection_date = new Date(date);
		let today_date = new Date();

		let date_difference = today_date.getTime() - inspection_date.getTime();
		let number_of_days = date_difference / (1000 * 3600 * 24);

		if (number_of_days >= 0 && number_of_days <= 28) {
			return false;
		}
		return true;
	}

	// Form input handler
	handleInput(e) {
		const { name, value, id } = e.target;
		this.setState({ [id]: value });

		if (value !== '') {
			const stateName = name.charAt(0).toUpperCase() + name.slice(1) + 'State';
			if (this.state.hasOwnProperty(stateName)) {
				this.setState({ [stateName]: 'has-success' });
			}
		} else {
			const stateName = name.charAt(0).toUpperCase() + name.slice(1) + 'State';
			if (this.state.hasOwnProperty(stateName)) {
				this.setState({ [stateName]: 'has-danger' });
			}
		}

		if (name === 'follow_up_comments') { // Changed to match DB column
			this.handleFollowupComment(id, value);
		} else if (name === 'followup_status') {
			this.handleFollowupStatus(id, value);
		}
	}

	// Handle follow-up comments (maps to follow_up_comments in DB)
	handleFollowupComment(recommendationId, value) {
		const input_object = recommendationId + ":" + value;
		const newComments = [...this.state.follow_up_comments];

		const existingIndex = newComments.findIndex(comment =>
			comment.state.startsWith(recommendationId + ":")
		);

		if (existingIndex >= 0) {
			newComments[existingIndex] = { state: input_object };
		} else {
			newComments.push({ state: input_object });
		}

		this.setState({ follow_up_comments: newComments });
	}

	// Handle follow-up status (maps to need_extra_followups in DB)
	handleFollowupStatus(recommendationId, value) {
		// Map UI status to DB enum (Yes/No)
		let dbValue = '';
		switch (value) {
			case 'Achieved':
				dbValue = 'No';
				break;
			case 'Partially Achieved':
			case 'Not Achieved':
				dbValue = 'Yes';
				break;
			default:
				dbValue = '';
		}

		const input_object = recommendationId + ":" + dbValue;
		const newStatus = [...this.state.followup_status];

		const existingIndex = newStatus.findIndex(status =>
			status.state.startsWith(recommendationId + ":")
		);

		if (existingIndex >= 0) {
			newStatus[existingIndex] = { state: input_object };
		} else {
			newStatus.push({ state: input_object });
		}

		this.setState({ followup_status: newStatus });
	}

	// Districts filter
	filterDistrictsAfterLoad(e) {
		const divisionId = e.target.value;
		this.setState({ division_id: divisionId }, () => {
			axios.get(API_URL + `/districts/filter/${divisionId}`, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			})
				.then(response => {
					if (response.data && response.data.data && Array.isArray(response.data.data)) {
						this.setState({ Districts: response.data.data });
					} else if (Array.isArray(response.data)) {
						this.setState({ Districts: response.data });
					} else {
						this.setState({ Districts: [] });
					}
				})
				.catch(error => {
					this.handleApiError(error);
					this.setState({ Districts: [] });
				});
		});
	}

	// Zones filter
	filterZonesAfterLoad(e) {
		const districtId = e.target.value;
		this.setState({ district_id: districtId }, () => {
			axios.get(API_URL + `/zones/filter/${districtId}`, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			})
				.then(response => {
					if (response.data && response.data.data && Array.isArray(response.data.data)) {
						this.setState({ Zones: response.data.data });
					} else if (Array.isArray(response.data)) {
						this.setState({ Zones: response.data });
					} else {
						this.setState({ Zones: [] });
					}
				})
				.catch(error => {
					this.handleApiError(error);
					this.setState({ Zones: [] });
				});
		});
	}

	// Schools filter
	filterSchoolsAfterLoad(e) {
		const zoneId = e.target.value;
		this.setState({ zone_id: zoneId }, () => {
			axios.get(API_URL + `/schools/filter/${zoneId}`, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			})
				.then(response => {
					if (response.data && response.data.data && Array.isArray(response.data.data)) {
						this.setState({ Schools: response.data.data });
					} else if (Array.isArray(response.data)) {
						this.setState({ Schools: response.data });
					} else {
						console.warn('Unexpected API response structure:', response.data);
						this.setState({ Schools: [] });
					}
				})
				.catch(error => {
					console.error('Error fetching schools:', error);
					this.setState({ Schools: [] });
					this.handleApiError(error);
				});
		});
	}

	getMinorRecommendationsByVisitId(e) {
		const visitId = e.target.value;
		if (!visitId) return;

		axios.get(API_URL + `/recommendations/followup_minor/${visitId}`, {
			headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
		})
			.then(response => {
				// FIX: Properly extract the data
				let recommendations = [];
				if (response.data) {
					if (Array.isArray(response.data)) {
						recommendations = response.data;
					} else if (response.data.data && Array.isArray(response.data.data)) {
						recommendations = response.data.data;
					}
				}

				this.setState({
					MinorRecommendations: recommendations
				});
			})
			.catch(error => {
				console.error('Error fetching minor recommendations:', error);
				this.setState({ MinorRecommendations: [] });
			});
	}
	getMajorRecommendationsByVisitId(e) {
		const visitId = e.target.value;
		if (!visitId) return;

		axios.get(API_URL + `/recommendations/major/${visitId}`, {
			headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
		})
			.then(response => {
				this.setState({
					MajorRecommendations: response.data || []
				});
			})
			.catch(error => {
				console.error('Error fetching major recommendations:', error);
			});
	}

	getActionPlansByVisitId(e) {
		const visitId = e.target.value;
		if (!visitId) return;

		axios.get(API_URL + `/action_plans/${visitId}`, {
			headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
		})
			.then(response => {
				this.setState({
					ActionPlans: response.data || []
				});
			})
			.catch(error => {
				console.error('Error fetching action plans:', error);
			});
	}

	// Get years for establishment year dropdown
	getYears() {
		const years = [];
		for (let i = new Date().getFullYear(); i >= 1500; i--) {
			years.push(i);
		}
		this.setState({ years });
	}

	// Set ID
	setId(e) {
		this.setState({ [e.target.id]: e.target.value });
	}

	// Get recent visits by school
	getRecentVisitsBySchool(e) {
		const schoolId = e.target.value;
		if (!schoolId) return;

		axios.get(API_URL + `/inspection_visits/recent/${schoolId}`, {
			headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
		})
			.then(response => {
				let visitsData = [];

				if (response.data && response.data.data && Array.isArray(response.data.data)) {
					visitsData = response.data.data;
				} else if (Array.isArray(response.data)) {
					visitsData = response.data;
				} else if (response.data && typeof response.data === 'object') {
					visitsData = response.data.data || [];
				}

				this.setState({
					recentVisits: visitsData,
					prev_visitation_date: visitsData.length > 0 ?
						visitsData[0]?.present_visitation_date || '' : ''
				});
			})
			.catch(error => {
				console.error('Error fetching recent visits:', error);
				this.setState({ recentVisits: [] });
			});
	}

	// Edit follow-up inspection visit
	// Edit follow-up inspection visit
	editInspectionVisit(id) {
		this.setState({ loading: true });

		const visit = this.state.Visits.find(v => v.visit_id === id);
		if (!visit) {
			this.setState({ loading: false });
			return;
		}

		// Fetch filtered data and related information
		Promise.all([
			axios.get(API_URL + `/inspection_visits/edit/${id}`, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			}),
			axios.get(API_URL + `/action_plans/${visit.assoc_visit}`, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			}),
			axios.get(API_URL + `/recommendations/major/${visit.assoc_visit}`, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			}),
			axios.get(API_URL + `/recommendations/followup_minor/edit/${id}`, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			}),
			axios.get(API_URL + `/inspection_visits/recent/${visit.school_id}`, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			}),
			axios.get(API_URL + `/districts/filter/${visit.division_id}`, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			}),
			axios.get(API_URL + `/zones/filter/${visit.district_id}`, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			}),
			axios.get(API_URL + `/schools/filter/${visit.zone_id}`, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			})
		])
			.then(([visitData, actionPlans, majorRecs, minorRecs, recentVisitsRes, districts, zones, schools]) => {
				const visitDetails = visitData.data?.[0] || {};

				// FIX: Properly extract recommendation data from the response
				let recommendationData = [];

				// Check if minorRecs has the expected structure
				if (minorRecs.data) {
					if (Array.isArray(minorRecs.data)) {
						// Direct array
						recommendationData = minorRecs.data;
					} else if (minorRecs.data.data && Array.isArray(minorRecs.data.data)) {
						// Paginated response
						recommendationData = minorRecs.data.data;
					}
				}

				// Process recent visits response
				let recentVisitsData = [];
				if (recentVisitsRes.data) {
					if (Array.isArray(recentVisitsRes.data)) {
						recentVisitsData = recentVisitsRes.data;
					} else if (recentVisitsRes.data.data && Array.isArray(recentVisitsRes.data.data)) {
						recentVisitsData = recentVisitsRes.data.data;
					}
				}

				// Process major recommendations
				let majorRecsData = [];
				if (majorRecs.data) {
					if (Array.isArray(majorRecs.data)) {
						majorRecsData = majorRecs.data;
					} else if (majorRecs.data.data && Array.isArray(majorRecs.data.data)) {
						majorRecsData = majorRecs.data.data;
					}
				}

				// Process action plans
				let actionPlansData = [];
				if (actionPlans.data) {
					if (Array.isArray(actionPlans.data)) {
						actionPlansData = actionPlans.data;
					} else if (actionPlans.data.data && Array.isArray(actionPlans.data.data)) {
						actionPlansData = actionPlans.data.data;
					}
				}

				// Process districts
				let districtsData = [];
				if (districts.data) {
					if (Array.isArray(districts.data)) {
						districtsData = districts.data;
					} else if (districts.data.data && Array.isArray(districts.data.data)) {
						districtsData = districts.data.data;
					}
				}

				// Process zones
				let zonesData = [];
				if (zones.data) {
					if (Array.isArray(zones.data)) {
						zonesData = zones.data;
					} else if (zones.data.data && Array.isArray(zones.data.data)) {
						zonesData = zones.data.data;
					}
				}

				// Process schools
				let schoolsData = [];
				if (schools.data) {
					if (Array.isArray(schools.data)) {
						schoolsData = schools.data;
					} else if (schools.data.data && Array.isArray(schools.data.data)) {
						schoolsData = schools.data.data;
					}
				}

				// Process follow-up comments (matching DB column follow_up_comments)
				const comments = recommendationData.map(rec => ({
					state: rec.recommendation_id + ":" + (rec.follow_up_comments || '')
				}));

				// Process status (matching DB column need_extra_followups)
				const statuses = recommendationData.map(rec => ({
					state: rec.recommendation_id + ":" + (rec.need_extra_followups || '')
				}));

				this.setState({
					recentVisits: recentVisitsData,
					MajorRecommendations: majorRecsData,
					ActionPlans: actionPlansData,
					visit: recentVisitsData.find(d => d.visit_id === visitDetails.assoc_visit) || {},
					followup_visit: visitDetails,
					id: visitDetails.assoc_visit,
					school_id: visitDetails.school_id || visitDetails.emis_id,
					zone_id: visitDetails.zone_id,
					district_id: visitDetails.district_id,
					assoc_visit: visitDetails.assoc_visit,
					division_id: visitDetails.division_id,
					present_visitation_date: visitDetails.present_visitation_date,
					prev_visitation_date: visitDetails.prev_visitation_date,
					lead_inspector_id: visitDetails.lead_inspector_id,
					first_inspector_id: visitDetails.first_inspector_id,
					second_inspector_id: visitDetails.second_inspector_id,
					third_inspector_id: visitDetails.third_inspector_id,
					fourth_inspector_id: visitDetails.fourth_inspector_id,
					follow_up_comments: comments,
					followup_status: statuses,
					MinorRecommendations: recommendationData,
					Districts: districtsData,
					Zones: zonesData,
					Schools: schoolsData,
					EditModalVisible: true,
					loading: false
				});
			})
			.catch(error => {
				console.error('Error in editInspectionVisit:', error);
				this.setState({ loading: false });
				this.handleApiError(error);
			});
	}

	// Update follow-up inspection visit
	updateInspectionVisit(event) {
		event.preventDefault();
		this.setState({ loading: true });

		const followupId = this.state.followup_visit.visit_id;
		const id = this.state.assoc_visit;

		const followup_inspection = {
			school_id: this.state.school_id,
			head_teacher: 'Not collected',
			phone_number: 'Not collected',
			present_visitation_date: this.state.present_visitation_date,
			prev_visitation_date: 'Not collected',
			lead_inspector_id: this.state.lead_inspector_id,
			first_inspector_id: this.state.first_inspector_id,
			second_inspector_id: this.state.second_inspector_id,
			third_inspector_id: this.state.third_inspector_id || null,
			fourth_inspector_id: this.state.fourth_inspector_id || null,
			school_address: 'Not collected',
			establishment_year: '0000',
			enrolment_boys: '0',
			enrolment_girls: '0',
			attendance_boys: '0',
			attendance_girls: '0',
			number_of_teachers: '0',
			unqualified_teachers: '0',
			publication_date: '00/00/0000',
			action_plan_date: '00/00/0000',
			next_inspection_date: '00/00/00',
			zone_id: this.state.zone_id,
			sector_id: this.state.sector_id,
			district_id: this.state.district_id,
			division_id: this.state.division_id,
			lead_advisor_id: 'Not collected',
			govt_chair_id: 'Not collected',
			visit_type_id: '2',
			assoc_visit: this.state.assoc_visit,
		};


		const recommendations_update = {
			followup_comments: this.state.follow_up_comments,   // matches $request->get('followup_comments')
			followup_status: this.state.followup_status,         // matches $request->get('followup_status')
		};

		Promise.all([
			axios.patch(API_URL + `/inspection_visits/update/${followupId}`, followup_inspection, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			}),
			axios.patch(API_URL + `/recommendations/minor/update_followup/${id}`, recommendations_update, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			})
		])
			.then(([visitResponse, recommendationResponse]) => {
				if (visitResponse.data.status === 'success') {
					swal({
						title: "Success",
						text: visitResponse.data.message,
						icon: "success",
						timer: 1250
					}).then(() => {
						this.setState({ EditModalVisible: false, loading: false }, () => {
							this.tableRef.current && this.tableRef.current.onQueryChange();
						});
					});
				} else {
					swal({
						title: "Error",
						text: visitResponse.data.message,
						icon: "error",
						button: true
					});
					this.setState({ loading: false });
				}
			})
			.catch(error => {
				this.setState({ loading: false });
				this.handleApiError(error);
			});
	}

	// Delete follow-up inspection visit
	deleteInspectionVisit(id) {
		swal({
			title: "Confirm Delete",
			text: "Are you sure you want to delete this follow-up inspection visit?",
			icon: "warning",
			dangerMode: true,
			buttons: ["Cancel", "Delete"]
		}).then(willDelete => {
			if (willDelete) {
				this.setState({ loading: true });

				axios.delete(API_URL + `/inspection_visits/delete/${id}`, {
					headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
				})
					.then(response => {
						if (response.data.status === 'success') {
							swal({
								title: "Deleted",
								text: "Follow-up visit deleted successfully!",
								icon: "success",
								timer: 2000
							}).then(() => {
								this.setState({ loading: false, page: 0 }, () => {
									this.tableRef.current && this.tableRef.current.onQueryChange();
								});
							});
						} else {
							swal({
								title: "Error",
								text: response.data.message || "Failed to delete follow-up visit",
								icon: "error",
								button: true
							});
							this.setState({ loading: false });
						}
					})
					.catch(error => {
						this.setState({ loading: false });
						this.handleApiError(error);
					});
			}
		});
	}

	// Add follow-up inspection visit
	addInspectionVisit(event) {
		event.preventDefault();
		this.setState({ loading: true });

		const followup_inspection = {
			school_id: this.state.school_id,
			head_teacher: 'Not collected',
			phone_number: 'Not collected',
			present_visitation_date: this.state.present_visitation_date,
			prev_visitation_date: 'Not collected',
			lead_inspector_id: this.state.lead_inspector_id,
			first_inspector_id: this.state.first_inspector_id,
			second_inspector_id: this.state.second_inspector_id,
			third_inspector_id: this.state.third_inspector_id || null,
			fourth_inspector_id: this.state.fourth_inspector_id || null,
			school_address: 'Not collected',
			establishment_year: '0000',
			enrolment_boys: '0',
			enrolment_girls: '0',
			attendance_boys: '0',
			attendance_girls: '0',
			number_of_teachers: '0',
			unqualified_teachers: '0',
			publication_date: '00/00/0000',
			action_plan_date: '00/00/0000',
			next_inspection_date: '00/00/00',
			zone_id: this.state.zone_id,
			sector_id: this.state.sector_id,
			district_id: this.state.district_id,
			division_id: this.state.division_id,
			lead_advisor_id: 'Not collected',
			govt_chair_id: 'Not collected',
			visit_type_id: '2',
			assoc_visit: this.state.assoc_visit,
		};



		const recommendations_update = {
			followup_comments: this.state.follow_up_comments,   // matches $request->get('followup_comments')
			followup_status: this.state.followup_status,         // matches $request->get('followup_status')
		};

		Promise.all([
			axios.post(API_URL + `/inspection_visits/followup`, followup_inspection, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			}),
			axios.patch(API_URL + `/recommendations/minor/update_followup/${this.state.assoc_visit}`, recommendations_update, {
				headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
			})
		])
			.then(([visitResponse, recommendationResponse]) => {
				if (visitResponse.data.status === 'success') {
					swal({
						title: "Success",
						text: visitResponse.data.message,
						icon: "success",
						timer: 1500,
						button: false
					}).then(() => {
						this.setState({ modalVisible: false, loading: false, page: 0 }, () => {
							this.tableRef.current && this.tableRef.current.onQueryChange();
						});
					});
				} else {
					swal({
						title: "Error",
						text: visitResponse.data.message,
						icon: "error",
						timer: 3000,
						button: false
					});
					this.setState({ loading: false });
				}
			})
			.catch(error => {
				this.setState({ loading: false });
				this.handleApiError(error);
			});
	}
	render() {
		const {
			Visits, Divisions, Users, loading, isFetching, modalVisible,
			EditModalVisible, role, sector_id, error, totalCount,
			Districts, Zones, Schools, recentVisits, MinorRecommendations,
			MajorRecommendations, national_standards
		} = this.state;

		const columns = [
			{
				title: 'School',
				field: 'school_name',
				render: rowData => (
					<div>
						<div><strong>{rowData.school_name}</strong></div>
						<small className="text-muted">EMIS: {rowData.emis_id || 'N/A'}</small>
					</div>
				)
			},
			{
				title: 'Follow-up Date',
				field: 'present_visitation_date',
				width: 120,
				render: rowData => (
					<div>
						<div>{new Date(rowData.present_visitation_date).toLocaleDateString()}</div>
						<small className="text-muted">
							{rowData.visit_type_description || 'Follow-up'}
						</small>
					</div>
				)
			},
			{
				title: 'Location',
				field: 'zone_name',
				width: 180,
				render: rowData => (
					<div>
						<div>{rowData.zone_name} {sector_id == 1 ? 'Zone' : 'Cluster'}</div>
						<small className="text-muted">
							{rowData.district_name} • {rowData.division_name}
						</small>
					</div>
				)
			},
			{
				title: 'Lead Inspector',
				field: 'lead_inspector_id',
				width: 150,
				render: rowData => (
					<div>
						<div>{this.getInspectorName(rowData.lead_inspector_id)}</div>
					</div>
				)
			},
			{
				title: 'Actions',
				field: 'actions',
				export: false,
				sorting: false,
				width: 200,
				render: rowData => (
					<div className="d-flex">
						<Button
							color="link"
							size="sm"
							onClick={() => this.viewVisitDetails(rowData)}
							title="View Details"
							className="mr-1"
						>
							<i className="mdi mdi-eye-outline text-info"></i>
						</Button>

						{role === 'Inspector' &&
							(this.state.logged_user_id === rowData.lead_inspector_id ||
								this.state.logged_user_id === rowData.first_inspector_id ||
								this.state.logged_user_id === rowData.second_inspector_id) &&
							!this.calculateDateDifference(rowData.present_visitation_date) && (
								<Button
									color="link"
									size="sm"
									onClick={() => this.editInspectionVisit(rowData.visit_id)}
									title="Edit Visit"
									className="mr-1"
								>
									<Edit className="text-primary" />
								</Button>
							)}

						{role === 'Inspector' &&
							(this.state.logged_user_id === rowData.lead_inspector_id ||
								this.state.logged_user_id === rowData.first_inspector_id ||
								this.state.logged_user_id === rowData.second_inspector_id) &&
							!this.calculateDateDifference(rowData.present_visitation_date) && (
								<Button
									color="link"
									size="sm"
									onClick={() => this.deleteInspectionVisit(rowData.visit_id)}
									title="Delete Visit"
									className="mr-1"
								>
									<Delete className="text-danger" />
								</Button>
							)}

						{(role === 'Inspector' || role === 'PEA' ||
							role === 'Secondary Advisor' || role === 'Head Teacher') && (
								<Link
									className="btn btn-primary btn-sm"
									to={`/followup-report/${rowData.assoc_visit}/${rowData.visit_id}`}
									title="View Report"
								>
									VIEW REPORT
								</Link>
							)}
					</div>
				)
			}
		];

		const totalVisits = this.state.totalCount;
		const recentVisitsCount = Visits.filter(v =>
			moment(v.present_visitation_date).isAfter(moment().subtract(30, 'days'))
		).length;

		return (
			<Container fluid>
				{isFetching && <Loader />}

				<Row className="align-items-center mb-4">
					<Col sm={6}>
						<div className="page-title-box">
							<h4 className="page-title mb-0">
								<i className="mdi mdi-school mr-2"></i>
								Follow-up Inspection Visits
							</h4>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item">
									<Link to="/dashboard">Home</Link>
								</li>
								<li className="breadcrumb-item active">Follow-up Inspections</li>
							</ol>
						</div>
					</Col>
					<Col sm={6} className="text-right">
						<Button
							color="success"
							onClick={this.toggle}
							disabled={!['Secondary Advisor', 'Inspector', 'PEA'].includes(role)}
							className="mr-2"
						>
							<Add /> New Follow-up Visit
						</Button>
						<div className="badge badge-light p-2">
							<i className="mdi mdi-counter mr-1"></i>
							{totalVisits.toLocaleString()} Follow-up Visits
						</div>
					</Col>
				</Row>

				{error && (
					<Row className="mb-3">
						<Col>
							<Alert color="danger">
								<h5 className="alert-heading">Error Loading Data</h5>
								<p>{error}</p>
							</Alert>
						</Col>
					</Row>
				)}

				<Row>
					<Col>
						<Card>
							<CardBody>
								<div className="d-flex justify-content-between align-items-center mb-3">
									<h5 className="card-title mb-0">{this.getJurisdictionText()}</h5>
								</div>

								<p className="text-muted mb-4">
									Manage follow-up school inspection visits to track progress on recommendations and action plans.
								</p>

								<MaterialTable
									tableRef={this.tableRef}
									title="Follow-up Inspection Visits"
									columns={columns}
									data={query => {
										return new Promise((resolve, reject) => {
											const page = query.page;
											const pageSize = query.pageSize;
											const search = query.search || '';

											this.fetchData(page, pageSize, search)
												.then(() => {
													resolve({
														data: this.state.Visits,
														page: this.state.page,
														totalCount: this.state.totalCount
													});
												})
												.catch(error => {
													reject(error);
												});
										});
									}}
									isLoading={isFetching}
									options={{
										exportButton: {
											csv: true,
											pdf: false
										},
										exportFileName: `followup-inspection-visits-${moment().format('YYYY-MM-DD')}`,
										tableLayout: 'auto',
										loadingType: 'linear',
										pageSize: this.state.pageSize,
										pageSizeOptions: [5, 10, 20, 50, 100],
										emptyRowsWhenPaging: false,
										columnsButton: true,
										exportAllData: false,
										actionsColumnIndex: -1,
										search: true,
										sorting: true,
										debounceInterval: 500,
										showFirstLastPageButtons: true,
										paginationType: 'normal',
										padding: 'dense',
										rowStyle: {
											fontSize: '0.9rem'
										},
										headerStyle: {
											backgroundColor: '#f8f9fa',
											fontWeight: '600',
											fontSize: '0.9rem'
										},
										paging: true,
										serverSide: true,
										pagingPosition: 'bottom'
									}}
									localization={{
										body: {
											emptyDataSourceMessage: 'No follow-up inspection visits found. Create a new follow-up visit to get started.',
											addTooltip: 'Add',
											deleteTooltip: 'Delete',
											editTooltip: 'Edit',
											filterRow: {
												filterTooltip: 'Filter'
											}
										},
										pagination: {
											labelRowsSelect: 'rows per page',
											labelDisplayedRows: '{from}-{to} of {count}',
											firstTooltip: 'First Page',
											previousTooltip: 'Previous Page',
											nextTooltip: 'Next Page',
											lastTooltip: 'Last Page'
										},
										toolbar: {
											searchTooltip: 'Search follow-up inspection visits',
											searchPlaceholder: 'Search by school, lead inspector, or location...',
											exportTitle: 'Export',
											exportName: 'Export as CSV',
											exportCSVName: 'Export as CSV'
										},
										header: {
											actions: 'Actions'
										}
									}}
								/>
							</CardBody>
						</Card>
					</Col>
				</Row>

				<Row className="mt-3">
					<Col>
						<Card className="border">
							<CardBody className="py-3">
								<Row>
									<Col md={4} className="text-center border-right">
										<h4 className="mb-1 text-primary">{totalVisits.toLocaleString()}</h4>
										<small className="text-muted">Total Follow-up Visits</small>
									</Col>
									<Col md={4} className="text-center border-right">
										<h4 className="mb-1 text-success">{recentVisitsCount}</h4>
										<small className="text-muted">Last 30 Days</small>
									</Col>
									<Col md={4} className="text-center">
										<h4 className="mb-1 text-info">
											{Visits.filter(v => v.lead_inspector_id === this.state.logged_user_id).length}
										</h4>
										<small className="text-muted">My Follow-up Visits</small>
									</Col>
								</Row>
							</CardBody>
						</Card>
					</Col>
				</Row>

				{/* Add Follow-up Inspection Visit Modal */}
				<Modal isOpen={modalVisible} toggle={this.toggle} size="xl">
					<Form onSubmit={this.addInspectionVisit}>
						<ModalHeader toggle={this.toggle}>
							<center>FOLLOW-UP INSPECTION VISIT FORM</center>
						</ModalHeader>
						<ModalBody>
							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="division">Division Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="division_id"
											id="division_id"
											invalid={this.state.DivisionIdState === 'has-danger'}
											onChange={(e) => { this.handleInput(e); this.filterDistrictsAfterLoad(e); }}
											onBlur={this.handleInput}
											required
										>
											<option value="">Select Division</option>
											{Divisions.map(division => (
												<option value={division.division_id} key={division.division_id}>
													{division.division_name}
												</option>
											))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="district">District Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="district_id"
											id="district_id"
											invalid={this.state.DistrictIdState === 'has-danger'}
											onChange={(e) => { this.handleInput(e); this.filterZonesAfterLoad(e); }}
											onBlur={this.handleInput}
											required
											disabled={!Districts.length}
										>
											<option value="">Select District</option>
											{Districts.map(district => (
												<option value={district.district_id} key={district.district_id}>
													{district.district_name}
												</option>
											))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="zone">
											{this.state.sector_id == 1 ? 'Zone Name' : this.state.sector_id == 2 ? 'Cluster Name' : 'Zone/Cluster Name'}
											<span className="text-danger">*</span>
										</Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="zone_id"
											id="zone_id"
											invalid={this.state.ZoneIdState === 'has-danger'}
											onChange={(e) => { this.handleInput(e); this.filterSchoolsAfterLoad(e); }}
											onBlur={this.handleInput}
											required
											disabled={!Zones.length}
										>
											<option value="">Select {this.state.sector_id == 1 ? 'Zone' : 'Cluster'}</option>
											{Zones
												.filter(zone => !this.state.sector_id || zone.sector_id == this.state.sector_id)
												.map(zone => (
													<option value={zone.zone_id} key={zone.zone_id}>
														{zone.zone_name}
													</option>
												))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="school">School Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="school_id"
											id="school_id"
											invalid={this.state.SchoolIdState === 'has-danger'}
											onChange={(e) => { this.handleInput(e); this.getRecentVisitsBySchool(e); }}
											onBlur={this.handleInput}
											required
											disabled={!Schools.length}
										>
											<option value="">Select School</option>
											{Schools.map(school => (
												<option value={school.school_id} key={school.school_id}>
													{school.school_name}
												</option>
											))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="assoc_visit">Original School Visit <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="assoc_visit"
											id="assoc_visit"
											invalid={this.state.VisitIdState === 'has-danger'}
											onChange={(e) => {
												this.handleInput(e);
												this.getMinorRecommendationsByVisitId(e);
												this.getMajorRecommendationsByVisitId(e);
												this.getActionPlansByVisitId(e);
											}}
											onBlur={this.handleInput}
											required
											disabled={!recentVisits.length}
										>
											<option value="">Select Original Visit</option>
											{recentVisits.map(visit => (
												<option value={visit.visit_id} key={visit.visit_id}>
													{visit.school_name + " conducted on " +
														new Date(visit.present_visitation_date).toLocaleDateString()}
												</option>
											))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="present_visitation_date">Follow-up Visitation Date <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="date"
											name="present_visitation_date"
											id="present_visitation_date"
											invalid={this.state.presentDateState === 'has-danger'}
											onChange={this.handleInput}
											onBlur={this.handleInput}
											required
											value={this.state.present_visitation_date}
										/>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="lead_inspector_id">Lead Inspector Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="lead_inspector_id"
											id="lead_inspector_id"
											invalid={this.state.leadInspectorIdState === 'has-danger'}
											onChange={this.handleInput}
											onBlur={this.handleInput}
											required
										>
											<option value="">Select Lead Inspector</option>
											{Users
												.filter(user => user.sector_id == this.state.sector_id &&
													user.user_role == 'Inspector' &&
													user.user_id != this.state.fourth_inspector_id &&
													user.user_id != this.state.second_inspector_id &&
													user.user_id != this.state.third_inspector_id &&
													user.user_id != this.state.first_inspector_id)
												.map(user => (
													<option value={user.user_id} key={user.user_id}>
														{user.user_name}
													</option>
												))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="first_inspector_id">First Inspector Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="first_inspector_id"
											id="first_inspector_id"
											invalid={this.state.firstInspectorIdState === 'has-danger'}
											onChange={this.handleInput}
											onBlur={this.handleInput}
											required
										>
											<option value="">Select First Inspector</option>
											{Users
												.filter(user => user.sector_id == this.state.sector_id &&
													user.user_role == 'Inspector' &&
													user.user_id != this.state.fourth_inspector_id &&
													user.user_id != this.state.second_inspector_id &&
													user.user_id != this.state.third_inspector_id &&
													user.user_id != this.state.lead_inspector_id)
												.map(user => (
													<option value={user.user_id} key={user.user_id}>
														{user.user_name}
													</option>
												))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="second_inspector_id">Second Inspector Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="second_inspector_id"
											id="second_inspector_id"
											invalid={this.state.secondInspectorIdState === 'has-danger'}
											onChange={this.handleInput}
											onBlur={this.handleInput}
											required
										>
											<option value="">Select Second Inspector</option>
											{Users
												.filter(user => user.sector_id == this.state.sector_id &&
													user.user_role == 'Inspector' &&
													user.user_id != this.state.first_inspector_id &&
													user.user_id != this.state.fourth_inspector_id &&
													user.user_id != this.state.third_inspector_id &&
													user.user_id != this.state.lead_inspector_id)
												.map(user => (
													<option value={user.user_id} key={user.user_id}>
														{user.user_name}
													</option>
												))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<div className="mt-4">
								<h5>Action Plan for Original Visit</h5>
								{MajorRecommendations && MajorRecommendations.length > 0 && (
									<GanttChart
										editMode={false}
										visit={this.state.Visits.filter(v => v.visit_id === this.state.assoc_visit)}
										updateRecommendationsList={() => { }}
										categories={this.state.categories}
										recommendations={MajorRecommendations}
									/>
								)}
							</div>

							<div className="mt-4">
								<h5>Minor Recommendations Follow-up</h5>
								<Table responsive striped size="lg">
									<thead>
										<tr>
											<th style={{ width: '20%' }}>NES</th>
											<th style={{ width: '30%' }}>Minor Recommendations</th>
											<th style={{ width: '30%' }}>Follow-up Comments</th>
											<th style={{ width: '20%' }}>Need Extra Follow-up?</th>
										</tr>
									</thead>
									<tbody>
										{MinorRecommendations.length > 0 ? (
											MinorRecommendations.map(rcmdtn => (
												<tr key={rcmdtn.recommendation_id}>
													<td>
														{national_standards.find(cat => cat.nes_id == rcmdtn.nes_id)?.nes_name || 'N/A'}
													</td>
													<td>{rcmdtn.recommendation_description}</td>
													<td>
														<Input
															type="textarea"
															name="follow_up_comments"
															id={rcmdtn.recommendation_id}
															defaultValue={rcmdtn.follow_up_comments || ''}
															onChange={(e) => { this.handleInput(e); }}
														/>
													</td>
													<td>
														<Input
															type="select"
															name="followup_status"
															id={rcmdtn.recommendation_id}
															defaultValue={this.mapDBValueToUI(rcmdtn.need_extra_followups)}
															onChange={(e) => { this.handleInput(e); }}
														>
															<option value="">Select Status</option>
															<option value="Achieved">Achieved</option>
															<option value="Partially Achieved">Partially Achieved</option>
															<option value="Not Achieved">Not Achieved</option>
														</Input>
													</td>
												</tr>
											))
										) : (
											<tr>
												<td colSpan="4" className="text-center">
													No minor recommendations found for the selected visit.
												</td>
											</tr>
										)}
									</tbody>
								</Table>
							</div>
						</ModalBody>
						<ModalFooter>
							<Button type="submit" color="success" disabled={loading}>
								{loading ? 'Processing...' : 'Create'}
							</Button>
							<Button color="danger" onClick={this.toggle}>Cancel</Button>
						</ModalFooter>
					</Form>
				</Modal>

				{/* Edit Follow-up Inspection Visit Modal */}
				<Modal isOpen={EditModalVisible} toggle={this.toggleEdit} size="xl">
					<Form onSubmit={this.updateInspectionVisit}>
						<ModalHeader toggle={this.toggleEdit}>
							<center>EDIT FOLLOW-UP INSPECTION VISIT</center>
						</ModalHeader>
						<ModalBody>
							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="division">Division Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="division_id"
											id="division_id"
											value={this.state.division_id}
											invalid={this.state.DivisionIdState === 'has-danger'}
											onChange={(e) => { this.handleInput(e); this.filterDistrictsAfterLoad(e); }}
											onBlur={this.handleInput}
											required
										>
											<option value="">Select Division</option>
											{Divisions.map(division => (
												<option value={division.division_id} key={division.division_id}>
													{division.division_name}
												</option>
											))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="district">District Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="district_id"
											id="district_id"
											value={this.state.district_id}
											invalid={this.state.DistrictIdState === 'has-danger'}
											onChange={(e) => { this.handleInput(e); this.filterZonesAfterLoad(e); }}
											onBlur={this.handleInput}
											required
											disabled={!Districts.length}
										>
											<option value="">Select District</option>
											{Districts.map(district => (
												<option value={district.district_id} key={district.district_id}>
													{district.district_name}
												</option>
											))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="zone">
											{this.state.sector_id == 1 ? 'Zone Name' : this.state.sector_id == 2 ? 'Cluster Name' : 'Zone/Cluster Name'}
											<span className="text-danger">*</span>
										</Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="zone_id"
											id="zone_id"
											value={this.state.zone_id}
											invalid={this.state.ZoneIdState === 'has-danger'}
											onChange={(e) => { this.handleInput(e); this.filterSchoolsAfterLoad(e); }}
											onBlur={this.handleInput}
											required
											disabled={!Zones.length}
										>
											<option value="">Select {this.state.sector_id == 1 ? 'Zone' : 'Cluster'}</option>
											{Zones
												.filter(zone => !this.state.sector_id || zone.sector_id == this.state.sector_id)
												.map(zone => (
													<option value={zone.zone_id} key={zone.zone_id}>
														{zone.zone_name}
													</option>
												))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="school">School Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="school_id"
											id="school_id"
											value={this.state.school_id}
											invalid={this.state.SchoolIdState === 'has-danger'}
											onChange={(e) => { this.handleInput(e); this.getRecentVisitsBySchool(e); }}
											onBlur={this.handleInput}
											required
											disabled={!Schools.length}
										>
											<option value="">Select School</option>
											{Schools.map(school => (
												<option value={school.school_id} key={school.school_id}>
													{school.school_name}
												</option>
											))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="assoc_visit">Original School Visit <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="assoc_visit"
											id="assoc_visit"
											value={this.state.assoc_visit}
											invalid={this.state.VisitIdState === 'has-danger'}
											onChange={(e) => {
												this.handleInput(e);
												this.getMinorRecommendationsByVisitId(e);
												this.getMajorRecommendationsByVisitId(e);
												this.getActionPlansByVisitId(e);
											}}
											onBlur={this.handleInput}
											required
											disabled={!recentVisits.length}
										>
											<option value="">Select Original Visit</option>
											{recentVisits.map(visit => (
												<option value={visit.visit_id} key={visit.visit_id}>
													{visit.school_name + " conducted on " +
														new Date(visit.present_visitation_date).toLocaleDateString()}
												</option>
											))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="present_visitation_date">Follow-up Visitation Date <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="date"
											name="present_visitation_date"
											id="present_visitation_date"
											value={this.state.present_visitation_date}
											invalid={this.state.presentDateState === 'has-danger'}
											onChange={this.handleInput}
											onBlur={this.handleInput}
											required
										/>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="lead_inspector_id">Lead Inspector Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="lead_inspector_id"
											id="lead_inspector_id"
											value={this.state.lead_inspector_id}
											invalid={this.state.leadInspectorIdState === 'has-danger'}
											onChange={this.handleInput}
											onBlur={this.handleInput}
											required
										>
											<option value="">Select Lead Inspector</option>
											{Users
												.filter(user => user.sector_id == this.state.sector_id &&
													user.user_role == 'Inspector' &&
													user.user_id != this.state.fourth_inspector_id &&
													user.user_id != this.state.second_inspector_id &&
													user.user_id != this.state.third_inspector_id &&
													user.user_id != this.state.first_inspector_id)
												.map(user => (
													<option value={user.user_id} key={user.user_id}>
														{user.user_name}
													</option>
												))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="first_inspector_id">First Inspector Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="first_inspector_id"
											id="first_inspector_id"
											value={this.state.first_inspector_id}
											invalid={this.state.firstInspectorIdState === 'has-danger'}
											onChange={this.handleInput}
											onBlur={this.handleInput}
											required
										>
											<option value="">Select First Inspector</option>
											{Users
												.filter(user => user.sector_id == this.state.sector_id &&
													user.user_role == 'Inspector' &&
													user.user_id != this.state.fourth_inspector_id &&
													user.user_id != this.state.second_inspector_id &&
													user.user_id != this.state.third_inspector_id &&
													user.user_id != this.state.lead_inspector_id)
												.map(user => (
													<option value={user.user_id} key={user.user_id}>
														{user.user_name}
													</option>
												))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<FormGroup>
								<Row>
									<Col xs={4} sm={4} md={4} lg={4} xl={4}>
										<Label for="second_inspector_id">Second Inspector Name <span className="text-danger">*</span></Label>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8} xl={8}>
										<Input
											type="select"
											name="second_inspector_id"
											id="second_inspector_id"
											value={this.state.second_inspector_id}
											invalid={this.state.secondInspectorIdState === 'has-danger'}
											onChange={this.handleInput}
											onBlur={this.handleInput}
											required
										>
											<option value="">Select Second Inspector</option>
											{Users
												.filter(user => user.sector_id == this.state.sector_id &&
													user.user_role == 'Inspector' &&
													user.user_id != this.state.first_inspector_id &&
													user.user_id != this.state.fourth_inspector_id &&
													user.user_id != this.state.third_inspector_id &&
													user.user_id != this.state.lead_inspector_id)
												.map(user => (
													<option value={user.user_id} key={user.user_id}>
														{user.user_name}
													</option>
												))}
										</Input>
										<FormFeedback invalid>The field is required.</FormFeedback>
									</Col>
								</Row>
							</FormGroup>

							<div className="mt-4">
								<h5>Action Plan for Original Visit</h5>
								{MajorRecommendations && MajorRecommendations.length > 0 && (
									<GanttChart
										editMode={false}
										visit={this.state.Visits.filter(v => v.visit_id === this.state.assoc_visit)}
										updateRecommendationsList={() => { }}
										categories={this.state.categories}
										recommendations={MajorRecommendations}
									/>
								)}
							</div>

							<div className="mt-4">
								<h5>Minor Recommendations Follow-up</h5>
								<Table responsive striped size="lg">
									<thead>
										<tr>
											<th style={{ width: '20%' }}>NES</th>
											<th style={{ width: '30%' }}>Minor Recommendations</th>
											<th style={{ width: '30%' }}>Follow-up Comments</th>
											<th style={{ width: '20%' }}>Need Extra Follow-up?</th>
										</tr>
									</thead>
									<tbody>
										{MinorRecommendations.length > 0 ? (
											MinorRecommendations.map(rcmdtn => (
												<tr key={rcmdtn.recommendation_id}>
													<td>
														{national_standards.find(cat => cat.nes_id == rcmdtn.nes_id)?.nes_name || 'N/A'}
													</td>
													<td>{rcmdtn.recommendation_description}</td>
													<td>
														<Input
															type="textarea"
															name="follow_up_comments"
															id={rcmdtn.recommendation_id}
															defaultValue={rcmdtn.follow_up_comments || ''}
															onChange={(e) => { this.handleInput(e); }}
														/>
													</td>
													<td>
														<Input
															type="select"
															name="followup_status"
															id={rcmdtn.recommendation_id}
															defaultValue={this.mapDBValueToUI(rcmdtn.need_extra_followups)}
															onChange={(e) => { this.handleInput(e); }}
														>
															<option value="">Select Status</option>
															<option value="Achieved">Achieved</option>
															<option value="Partially Achieved">Partially Achieved</option>
															<option value="Not Achieved">Not Achieved</option>
														</Input>
													</td>
												</tr>
											))
										) : (
											<tr>
												<td colSpan="4" className="text-center">
													No minor recommendations found for the selected visit.
												</td>
											</tr>
										)}
									</tbody>
								</Table>
							</div>
						</ModalBody>
						<ModalFooter>
							<Button type="submit" color="success" disabled={loading}>
								{loading ? 'Processing...' : 'Update'}
							</Button>
							<Button color="danger" onClick={this.toggleEdit}>Cancel</Button>
						</ModalFooter>
					</Form>
				</Modal>
			</Container>
		);
	}

	// Helper method to map DB value to UI value
	mapDBValueToUI(dbValue) {
		if (dbValue === 'No') return 'Achieved';
		if (dbValue === 'Yes') return 'Not Achieved';
		return '';
	}
}

export default InspectionFollowup;